import script from "./SettingsSectionHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingsSectionHeader.vue?vue&type=script&setup=true&lang=js"

import "./SettingsSectionHeader.vue?vue&type=style&index=0&id=33f718be&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33f718be"]])

export default __exports__